import { ConfigOrderDetails, Field, FieldValue, HeaderBadge, OrderHeader, Section } from './types';

import OrderDetails from './OrderDetails';

export type { OrderHeader, HeaderBadge, Section, FieldValue, Field, ConfigOrderDetails };

export default OrderDetails;
